// Update only carts this browser explicitly opted into saving. No email or
// account identity is placed in browser storage, URLs, or an anonymous cart.
export function syncSavedCarts(items) {
  const requests = [];
  const keys = Array.from({ length: sessionStorage.length }, (_, i) => sessionStorage.key(i));
  for (const key of keys) {
    if (!key?.startsWith('cartRecovery:')) continue;
    const [, subdomain, store_id] = key.split(':');
    const token = sessionStorage.getItem(key);
    const storeItems = items.filter(item => item.store_id === store_id && !item.is_meal_pass && !item.is_catering && !item.is_custom_order);
    requests.push(fetch(`${process.env.REACT_APP_BACKEND_URL}/api/storefront-marketing/cart`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ subdomain, store_id, token,
        items: storeItems.map(({ image, delivery_instructions, ...item }) => item) }),
    }).then(response => {
      if (response.ok && !storeItems.length && sessionStorage.getItem(key) === token) sessionStorage.removeItem(key);
    }).catch(() => {}));
  }
  return Promise.all(requests);
}
